import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setCargoConsultaProvimentosMembros: ['cargo'],
    limpaFiltroConsultaProvimentosMembros: [],
    receberFiltroConsultaProvimentosMembros: ['filtroRecebido'],
    setStatusConsultaProvimentosMembros: ['status'],
})

const INITIAL_STATE = {
    cargo: '',
    status: { label: '', value: '' },
}

const setCargo = (state = INITIAL_STATE, action) => {
    return { ...state, cargo: action.cargo }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

const setStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: action.status }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_CARGO_CONSULTA_PROVIMENTOS_MEMBROS]: setCargo,
    [Types.LIMPA_FILTRO_CONSULTA_PROVIMENTOS_MEMBROS]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_PROVIMENTOS_MEMBROS]: receberFiltro,
    [Types.SET_STATUS_CONSULTA_PROVIMENTOS_MEMBROS]: setStatus,
})
